import { render, staticRenderFns } from "./editor_cvs_list.vue?vue&type=template&id=839ede64&scoped=true"
import script from "./editor_cvs_list.vue?vue&type=script&lang=js"
export * from "./editor_cvs_list.vue?vue&type=script&lang=js"
import style0 from "./editor_cvs_list.vue?vue&type=style&index=0&id=839ede64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "839ede64",
  null
  
)

export default component.exports